import React from 'react'

const ArrowDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    viewBox='0 0 12 8'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.59 0.59L6 5.17L1.41 0.59L7.15493e-08 2L6 8L12 2L10.59 0.59Z'
      fill='currentColor'
    />
  </svg>
)

export default ArrowDownIcon
